import React from 'react';
import { Link } from 'react-router-dom';
import { Result, Button, Space } from 'antd';
import { WarningOutlined } from '@ant-design/icons';

const Unauthorized = () => {
  return (
    <div style={{ 
      minHeight: '100vh', 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center',
      background: '#f0f2f5'
    }}>
      <Result
        icon={<WarningOutlined style={{ color: '#faad14' }} />}
        status="403"
        title="Доступ запрещен"
        subTitle="У вас нет прав для доступа к этой странице"
        extra={
          <Space>
            <Link to="/dashboard">
              <Button type="primary">
                Вернуться на дашборд
              </Button>
            </Link>
            <Link to="/">
              <Button>
                На главную
              </Button>
            </Link>
          </Space>
        }
      />
    </div>
  );
};

export default Unauthorized;
